import React from 'react';
import './App.css';

const PopularExamples = () => {
  // Using local videos from the user's folder
  const video1 = `${process.env.PUBLIC_URL}/images/fecf4ded-6825-4891-b701-a11fa647e026 (1).mp4`;
  const video2 = `${process.env.PUBLIC_URL}/images/sdtez7hexdrmt0cvpsw940fhvr_result_.mp4`;
  const video3 = `${process.env.PUBLIC_URL}/images/1e5643c3-3c61-462b-a91e-756cc1afd0e7.mp4`;
  
  // Create staggered arrays for adjacent interaction
  const videosCol1 = [video1, video2, video3, video1, video2, video3];
  const videosCol2 = [video2, video3, video1, video2, video3, video1];

  return (
    <div style={{ background: '#050505', minHeight: '100vh', overflow: 'hidden', padding: '10px 0 0', position: 'relative', textAlign: 'center' }}>
       {/* Ambient Background Glow with Pulse Animation */}
       <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60vw',
          height: '60vw',
          background: 'radial-gradient(circle, rgba(255, 77, 0, 0.08) 0%, rgba(0,0,0,0) 70%)',
          filter: 'blur(100px)',
          zIndex: 0,
          pointerEvents: 'none',
          animation: 'pulseGlow 8s ease-in-out infinite alternate'
       }} />

       <div className="glass-panel" style={{ position: 'relative', zIndex: 2, animation: 'fadeInUp 0.6s ease-out', marginBottom: '30px' }}>
         <h2 className="title-text gradient-text" style={{ 
             textShadow: '0 0 30px rgba(255, 161, 44, 0.3)',
             backgroundSize: '200% auto',
             animation: 'gradientMove 3s linear infinite'
         }}>Popular Examples</h2>
         <p className="title-desc" style={{ color: '#ccc' }}>Trending AI Shorts generated by our community.</p>
       </div>
       
       <div className="scroll-container" style={{ position: 'relative', zIndex: 1, animation: 'fadeIn 0.8s ease-out' }}>
          {/* Column 1 - Scrolling Up */}
          <div className="scroll-column up">
             {videosCol1.concat(videosCol1).map((src, i) => (
               <div key={`col1-${i}`} className="video-card">
                 <div className="video-overlay" />
                 <video src={src} autoPlay loop muted playsInline preload="metadata" />
                 <div className="card-content">
                    <span className="user-badge">@AI_Master</span>
                    <div className="card-stats">
                        <span>❤️ 2.4k</span>
                    </div>
                 </div>
               </div>
             ))}
          </div>

          {/* Column 2 - Scrolling Down */}
          <div className="scroll-column down">
             {videosCol2.concat(videosCol2).map((src, i) => (
               <div key={`col2-${i}`} className="video-card">
                 <div className="video-overlay" />
                 <video src={src} autoPlay loop muted playsInline preload="metadata" />
                 <div className="card-content">
                    <span className="user-badge">@CreativeBot</span>
                    <div className="card-stats">
                        <span>❤️ 8.1k</span>
                    </div>
                 </div>
               </div>
             ))}
          </div>
          
           {/* Column 3 - Scrolling Up (Slower) */}
          <div className="scroll-column up slow">
             {videosCol1.concat(videosCol1).map((src, i) => (
               <div key={`col3-${i}`} className="video-card">
                 <div className="video-overlay" />
                 <video src={src} autoPlay loop muted playsInline preload="metadata" />
                 <div className="card-content">
                    <span className="user-badge">@ShortsGen</span>
                    <div className="card-stats">
                        <span>❤️ 3.5k</span>
                    </div>
                 </div>
               </div>
             ))}
          </div>
       </div>

       <style>{`
          .scroll-container {
             display: flex;
             justify-content: center;
             gap: 30px;
             height: 85vh; 
             overflow: hidden;
             mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);
             -webkit-mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);
          }
          
          .scroll-column {
             width: 280px;
             display: flex;
             flex-direction: column;
             gap: 30px;
          }
          
          .video-card {
             border-radius: 20px;
             overflow: hidden;
             position: relative;
             height: 500px;
             flex-shrink: 0;
             box-shadow: 0 10px 40px rgba(0,0,0,0.6);
             border: 1px solid rgba(255,255,255,0.08);
             transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
             transform: scale(0.98);
          }

          .video-card:hover {
             transform: scale(1.02);
             box-shadow: 0 20px 50px rgba(255, 77, 0, 0.2);
             border-color: rgba(255, 161, 44, 0.5);
             z-index: 10;
          }

          .video-card:after {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 50%;
              height: 100%;
              background: linear-gradient(to right, transparent, rgba(255,255,255,0.1), transparent);
              transform: skewX(-25deg);
              transition: left 0.5s;
          }
          .video-card:hover:after {
              left: 150%;
          }
          
          .video-card video {
             width: 100%;
             height: 100%;
             object-fit: cover;
             filter: brightness(0.9);
             transition: filter 0.3s;
          }
          .video-card:hover video {
             filter: brightness(1.1);
          }

          /* Animations */
          .up { animation: scrollUp 50s linear infinite; }
          .down { animation: scrollDown 60s linear infinite; }
          .slow { animation-duration: 70s; }
          .scroll-column:hover { animation-play-state: paused; }

          @keyframes scrollUp {
             0% { transform: translateY(0); }
             100% { transform: translateY(-50%); }
          }
          @keyframes scrollDown {
             0% { transform: translateY(-50%); }
             100% { transform: translateY(0); }
          }
          
          @keyframes pulseGlow {
             0% { opacity: 0.5; transform: translate(-50%, -50%) scale(0.9); }
             100% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.1); }
          }
          
          @keyframes fadeInUp {
             from { opacity: 0; transform: translateY(20px); }
             to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes fadeIn {
             from { opacity: 0; }
             to { opacity: 1; }
          }
          
          .glass-panel {
              background: rgba(255, 255, 255, 0.03);
              backdrop-filter: blur(10px);
              border: 1px solid rgba(255, 255, 255, 0.05);
              padding: 20px 40px;
              border-radius: 20px;
              display: inline-block;
              box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
          }

          .card-content {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              padding: 20px;
              background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%);
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              color: white;
              opacity: 1; /* Always visible or 0 for hover only */
              transition: opacity 0.3s;
          }

          .user-badge {
              font-size: 0.9rem;
              font-weight: 600;
              background: rgba(255,255,255,0.1);
              padding: 4px 10px;
              border-radius: 20px;
              backdrop-filter: blur(4px);
          }

          .card-stats {
              font-size: 0.85rem;
              color: #ff4d4d;
              font-weight: bold;
              display: flex;
              align-items: center;
              gap: 5px;
          }

          @keyframes gradientMove {
             0% { background-position: 0% 50%; }
             100% { background-position: 100% 50%; }
          }
          
          @media (max-width: 768px) {
              .scroll-column:nth-child(3) { display: none; }
              .scroll-column { width: 45%; }
          }
       `}</style>
    </div>
  );
};

export default PopularExamples;
